import { api } from './api';

export interface Plan {
    id: number;
    name: string;
    price: string;
    currency: string;
    is_active: boolean;
    description: string | null;
    features: PlanFeature[];
}

export interface PlanFeature {
    name: string;
    is_included: boolean;
}

export interface PlansResponse {
    success: boolean;
    message: string;
    data: Plan[];
}

export const getPlans = (): Promise<PlansResponse> =>
    api.get<PlansResponse>('/plans');
